<template>
  <div class="propertyapp">
    <div class="header">
      <div class="title">后台管理</div>
      <div class="border"></div>
    </div>
    <div class="body">
      <div class="box">
        <div class="right">
          <div class="list">
            <div class="item" v-for="item in propertyappList" :key="item.id">
              <img :src="item.logo" alt="" />
              <div class="title">{{ item.title }}</div>
              <div class="text">{{ item.text }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive } from "vue";

import backstage1 from "../../../../assets/product/backstage1.png";
import backstage2 from "../../../../assets/product/backstage2.png";
import backstage3 from "../../../../assets/product/backstage3.png";
import backstage4 from "../../../../assets/product/backstage4.png";
import backstage5 from "../../../../assets/product/backstage5.png";
import backstage6 from "../../../../assets/product/backstage6.png";

export default {
  setup() {
    return reactive({
      propertyappList: [
        {
          id: 1,
          title: "报事报修",
          text: "业主一键报修，物业后台收到提醒，在线派单，迅速匹配维修人员上门服务，提升服务效率。",
          logo: backstage1,
        },
        {
          id: 2,
          title: "财务管理",
          text: "财务报单，掌上查阅，多维度数据分析，360°掌控全局。",
          logo: backstage2,
        },
        {
          id: 3,
          title: "人员管理",
          text: "业主、员工全方位针对性管理，各项信息一目了然，自定义分配任务，节省管理成本。",
          logo: backstage3,
        },
        {
          id: 4,
          title: "钥匙管理",
          text: "各类钥匙，智能分类，一键登记，取用方便。",
          logo: backstage4,
        },
        {
          id: 5,
          title: "报表中心",
          text: "各项报表，数据直观统计，自定义搜索，高效管理。",
          logo: backstage5,
        },
        {
          id: 6,
          title: "物联设备",
          text: "设备集中管理，系统自动生成管理任务，一键设置巡检/保养/维修周期，有效维持设备运行。",
          logo: backstage6,
        },
      ],
    });
  },
};
</script>

<style scoped>
.propertyapp {
  margin: 24px auto 0;
}
.header {
  width: 100%;
  margin: 0 auto;
}
.header .title {
  font-size: 16px;
  text-align: center;
  margin-top: 24px;
}
.header .border {
  width: 16px;
  height: 2px;
  background: #248efb;
  margin: 4px auto 0;
}


.body {
  margin-top: 40px;
  background: linear-gradient(180deg, #eff7ff 0%, #fdfeff 100%);
  box-shadow: inset 0px 10px 20px 1px rgba(31, 81, 210, 0.06);
}
.body .box {
    width: 92vw;
    margin: 0 auto;
    padding: 16px 0;
    text-align: center;
}
.body .box .left img {
  width: 350px;
}
.body .box .right .list {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
}
.body .box .right .list .item {
    width: 162px;
    text-align: center;
    margin: 16px auto;
}
.body .box .right .list .item img {
    width: 36px;
}
.body .box .right .list .item .title {
    font-size: 14px;
  margin-top: 12px;
  font-weight: 600;
}
.body .box .right .list .item .text {
    font-size: 12px;
  margin-top: 8px;
  color: #495a6c;
}
</style>
